import store from '../store/index'

export default class DocumentService {
    async getDocuments() {
        const data = await store.dispatch('jv/get', ['documents', {params: {include: 'staff'}}]);
        return Object.values(data)
    }

    async createDocument(payload) {
        return await store.dispatch('jv/post', payload)
    }

    async updateDocument(payload) {
        return await store.dispatch('jv/patch', payload)
    }

    async deleteDocument(id) {
        return await store.dispatch('jv/delete', `documents/${id}`)
    }

    logError(e) {
        const error = []
        if (e.response.data.errors) {
            // Work with each error from the JSONAPI 'errors' array
            for (const err of e.response.data.errors) {
                error.push(err.detail)
            }
        }
        return error
    }
}
